import React from 'react';
import './index.css';
import HorizontalVector from "./HorizontalVector";

function StatPage(props) {
    return (
        <>
            <div
                className="flex flex-row-reverse rounded-[min(1vw,2vh)] justify-center items-center h-[min(5vw,10vh)] text-white my-[min(1vw,2vh)] bg-[#001037]">

                {props.grades.map((item, index) => (
                    <div  onClick={() => props.setGradeIndex(index)}
                         className={`flex text-[min(1vw,2vh)] flex-row transition-all duration-400 cursor-pointer justify-center ml-[1%] border-[min(0.2vw,0.4vh)] border-[#4044ED] items-center rounded-[min(0.5vw,1vh)] w-[12%] h-[60%] bg-[#${index === props.situation["gradeIndex"] ? "4044ED" : "001037"}]`}>
                        {item[1]}
                    </div>
                ))}
            </div>
            <div
                className="flex flex-row text-[min(1vw,2vh)] w-full h-[min(40vw,80vh)] p-[min(1vw,2vh)] bg-[#001037] rounded-[min(1vw,2vh)] overflow-hidden justify-center items-center">
                <div className="flex flex-col h-full w-full">
                    <div className="flex flex-row-reverse h-[11%] mb-[2%] w-[100%] text-white text-[min(1.5vw,3vh)] border-b-2 border-white text-right items-center">
                        <span className="m-8">آمار هوش بازی های انجام شده</span>
                        <img className="h-[70%] ml-[5%]" src={"https://uploads.zibazi.tv/site/assets/organ/states/hooshbazi.png"} alt="icon"/>
                        <span className="text-[min(3vw,6vh)]">
                            {parseInt(props.stateData["state_games_stat"][props.grades[props.situation["gradeIndex"]][0]][props.category]["total_played"]).toLocaleString()}
                        </span>
                        <span className="mr-[min(1vw,2vh)]">
                            بازی
                        </span>
                    </div>

                    <div className="flex flex-row-reverse py-[1%] justify-center items-center h-[86%] w-full">

                        <div className="self_scrollbar flex flex-col overflow-y-scroll w-full h-full justify-start items-start text-white">
                            {props.StatItems.map((item) => (
                                <div className={"flex flex-row-reverse items-center justify-center w-full min-h-[20%]"}>
                                    <div className="flex h-full justify-end text-right items-center text-white w-[20%]">
                                        {item[1]}
                                        <img className="h-[40%] ml-[10%]" src={`https://uploads.zibazi.tv/site/assets/organ/states/icons/${item[0]}.png`} alt="icon"/>
                                    </div>
                                    <div className="flex h-[40%] justify-end items-center text-white w-[60%] bg-[#263C73] rounded-[min(0.5vw,1vh)] overflow-hidden">
                                        <HorizontalVector percent={parseInt(100*props.stateData["state_games_stat"][props.grades[props.situation["gradeIndex"]][0]][props.category][item[0]]["succeeded_levels"]/props.stateData["state_games_stat"][props.grades[props.situation["gradeIndex"]][0]][props.category][item[0]]["played_levels"])}/>
                                    </div>
                                    <div className="flex h-[40%] justify-center text-center items-center text-white w-[10%] mr-[2%] bg-[#263C73] rounded-[min(0.5vw,1vh)]">
                                        {parseInt(100*props.stateData["state_games_stat"][props.grades[props.situation["gradeIndex"]][0]][props.category][item[0]]["succeeded_levels"]/props.stateData["state_games_stat"][props.grades[props.situation["gradeIndex"]][0]][props.category][item[0]]["played_levels"])}%
                                    </div>
                                </div>
                            ))}
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
}

export default StatPage;